import { render, staticRenderFns } from "./UniversalSearchComponent.vue?vue&type=template&id=419c7a1a&scoped=true"
import script from "./UniversalSearchComponent.vue?vue&type=script&lang=js"
export * from "./UniversalSearchComponent.vue?vue&type=script&lang=js"
import style0 from "./UniversalSearchComponent.vue?vue&type=style&index=0&id=419c7a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c7a1a",
  null
  
)

export default component.exports